import useFiltro from "infra/helpers/useFiltro";
import ModalTabsParticipantes from "ui/components/ModalTabsParticipantes";
import useReenviarNotificacoesAssembleiaPergunta from "core/features/assembleia/hooks/useReenviarNotificacoes";
import useAssembleiaPessoasVotaram from "core/features/assembleia/hooks/useAssembleiaPessoasVotaram";
import useAssembleiaPessoasNaoVotaram from "core/features/assembleia/hooks/useAssembleiaPessoasNaoVotaram";
import { UnidadeParticipanteItem } from "features/assembleia/typings";

interface ModalVotantesProps {
  perguntaId: string;
  votacaoId: string;
  isOpen: boolean;
  onClose: () => any;
}

function ModalVotantes({
  perguntaId,
  votacaoId,
  isOpen,
  onClose,
}: ModalVotantesProps) {
  const { isLoading: isLoadingReenviarNotificacoes } =
    useReenviarNotificacoesAssembleiaPergunta();

  const { filtro: filtroVotaram, onChangeFiltro: onChangeFiltroVotaram } =
    useFiltro();
  const {
    data: listaVotaram,
    isLoading: isLoadingListaVotaram,
    isFetching: isFetchingListaVotaram,
  } = useAssembleiaPessoasVotaram({
    idAssembleia: votacaoId,
    idPergunta: perguntaId,
    page: filtroVotaram.page || 1,
  });

  const { filtro: filtroNaoVotaram, onChangeFiltro: onChangeFiltroNaoVotaram } =
    useFiltro();
  const {
    data: listaNaoVotaram,
    isLoading: isLoadingListaNaoVotaram,
    isFetching: isFetchingListaNaoVotaram,
  } = useAssembleiaPessoasNaoVotaram({
    idAssembleia: votacaoId,
    idPergunta: perguntaId,
    page: filtroNaoVotaram.page || 1,
  });

  const _isLoadingVotaram = isLoadingListaVotaram || isFetchingListaVotaram;
  const _isLoadingNaoVotaram =
    isLoadingListaNaoVotaram || isFetchingListaNaoVotaram;

  const mapItemsVotaram: UnidadeParticipanteItem[] =
    listaVotaram?.items.map((item) => ({
      proprietario: item.pessoa.nome,
      imagemUrl: item.pessoa.imagemUrl,
    })) || [];
  const metaItemsVotaram = listaVotaram?.meta;

  const mapItemsNaoVotaram: UnidadeParticipanteItem[] =
    listaNaoVotaram?.items.map((item) => ({
      proprietario: item.pessoa.nome,
      imagemUrl: item.pessoa.imagemUrl,
    })) || [];
  const metaItemsNaoVotaram = listaNaoVotaram?.meta;

  return (
    <ModalTabsParticipantes
      isOpen={isOpen}
      onClose={onClose}
      firstTabOnPaginate={(p) => onChangeFiltroVotaram("page", p)}
      firstTabTitle="Votaram"
      firstTabFiltro={filtroVotaram}
      firstTabData={
        listaVotaram
          ? {
              meta: metaItemsVotaram!,
              items: mapItemsVotaram,
            }
          : undefined
      }
      firstTabEmptyMessage="Nenhuma unidade votou"
      firstTabIsLoading={_isLoadingVotaram}
      firstTabRightElement={null}
      secondTabFiltro={filtroNaoVotaram}
      secondTabOnPaginate={(p) => onChangeFiltroNaoVotaram("page", p)}
      secondTabTitle="Não votaram"
      secondTabData={
        listaNaoVotaram
          ? {
              meta: metaItemsNaoVotaram!,
              items: mapItemsNaoVotaram,
            }
          : undefined
      }
      secondTabEmptyMessage="Não falta nenhuma unidade votar"
      secondTabIsLoading={_isLoadingNaoVotaram}
      // reenviarNotificacoes={() => {
      //   trackEvent(`Votacao_Participantes_Notificar`);
      //   reenviarNotificacoes({ id: perguntaId, votacaoId });
      // }}
      isLoadingReenviarNotificacoes={isLoadingReenviarNotificacoes}
      textCreatedAt="votou em"
    />
  );
}

export default ModalVotantes;
